export default __webpack_public_path__ + "static/media/InfoModalCloseButton.ac3abf13.svg";